import { createContext } from 'react';
import noop from 'lodash/noop';

import { AppSetting } from '../types';

interface AppSettingsContextType {
    settings: Record<string, any>;
    loading: boolean;
    fetch: () => Promise<void>;
    update: (key: string, value: any) => Promise<AppSetting>;
}

const AppSettingsContext = createContext<AppSettingsContextType>({
    settings: {},
    loading: false,
    fetch: () => Promise.resolve(),
    update: () => Promise.resolve({} as AppSetting)
});

export default AppSettingsContext;
